// Utility to merge built-in personalities with custom personas
import personalities from './personalities';

export const mergePersonalities = (customPersonas, agent) => {
  const builtInPersonalities = personalities[agent] || {};

  // Filter custom personas for this agent or 'all'
  const relevantCustom = customPersonas.filter(
    p => p.agent === agent || p.agent === 'all'
  );

  // Convert custom personas to personality format
  const customPersonalitiesMap = {};
  relevantCustom.forEach(persona => {
    // Use a custom ID format to differentiate from built-in
    const customId = `custom_${persona._id}`;
    customPersonalitiesMap[customId] = {
      name: persona.name,
      description: persona.description,
      content: persona.content,
      isCustom: true,
      _id: persona._id
    };
  });

  // Merge built-in and custom, with custom appearing after built-in
  return {
    ...builtInPersonalities,
    ...customPersonalitiesMap
  };
};

// Check if a personality ID is a custom one
export const isCustomPersonality = (personalityId) => {
  return personalityId && personalityId.startsWith('custom_');
};

// Extract the MongoDB ID from a custom personality ID
export const extractCustomId = (personalityId) => {
  if (isCustomPersonality(personalityId)) {
    return personalityId.replace('custom_', '');
  }
  return null;
};

// Get personality content for API calls
export const getPersonalityContent = (agent, personalityId, customPersonas) => {
  if (isCustomPersonality(personalityId)) {
    const customId = extractCustomId(personalityId);
    const persona = customPersonas.find(
      p => p._id === customId && (p.agent === agent || p.agent === 'all')
    );
    return persona ? persona.content : '';
  }

  // Built-in personality
  const builtIn = personalities[agent]?.[personalityId];
  return builtIn ? builtIn.content : '';
};

export default {
  mergePersonalities,
  isCustomPersonality,
  extractCustomId,
  getPersonalityContent
};
